var _path, _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUsdtPolygon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 27,
    viewBox: "0 0 32 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1161_14646",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 32,
    height: 27
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 0H0V26.1528H32V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1161_14646)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.0764 25.8339C20.125 25.8339 25.8339 20.125 25.8339 13.0764C25.8339 6.02794 20.125 0.31897 13.0764 0.31897C6.02794 0.31897 0.31897 6.02794 0.31897 13.0764C0.31897 20.125 6.02794 25.8339 13.0764 25.8339Z",
    fill: "#26A17B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.6393 13.9588C14.5542 13.9588 14.0971 13.9907 13.0871 13.9907C12.2791 13.9907 11.7157 13.9694 11.5137 13.9588C8.40936 13.8206 6.10238 13.2784 6.10238 12.6405C6.10238 12.0026 8.41999 11.4604 11.5137 11.3116V13.4166C11.7157 13.4272 12.3004 13.4697 13.0977 13.4697C14.0652 13.4697 14.5436 13.4272 14.6286 13.4272V11.3222C17.7223 11.4604 20.0293 12.0026 20.0293 12.6405C20.0399 13.2784 17.7329 13.8206 14.6393 13.9588ZM14.6393 11.099V9.20661H18.9555V6.33618H7.20803V9.21724H11.5243V11.099C8.016 11.2584 5.37946 11.9601 5.37946 12.7893C5.37946 13.6186 8.016 14.3202 11.5243 14.4797V20.5182H14.6393V14.4691C18.1369 14.3096 20.7735 13.6186 20.7735 12.7787C20.7735 11.9388 18.1476 11.2584 14.6393 11.099Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1161_14646)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.6237 13.0764C31.6237 17.0007 28.4425 20.1819 24.5183 20.1819C20.594 20.1819 17.4128 17.0007 17.4128 13.0764C17.4128 9.15218 20.594 5.97095 24.5183 5.97095C28.4425 5.97095 31.6237 9.15218 31.6237 13.0764Z",
    fill: "#6F41D8",
    stroke: "white",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.8592 11.5561C26.6895 11.4573 26.4693 11.4573 26.2827 11.5561L24.9592 12.3165L24.0604 12.8121L22.7369 13.572C22.5672 13.6713 22.347 13.6713 22.1604 13.572L21.1086 12.9771C20.9389 12.8783 20.8203 12.6967 20.8203 12.4981V11.3249C20.8203 11.1268 20.9219 10.9452 21.1086 10.8459L22.1429 10.2675C22.313 10.1682 22.5337 10.1682 22.7203 10.2675L23.7547 10.8459C23.9248 10.9452 24.0434 11.1268 24.0434 11.3249V12.0853L24.9421 11.5727V10.8128C24.9431 10.7141 24.9167 10.617 24.8658 10.5325C24.8149 10.4479 24.7416 10.3791 24.6539 10.3337L22.7369 9.2433C22.5672 9.144 22.347 9.144 22.1604 9.2433L20.2094 10.3337C20.1217 10.3791 20.0483 10.4479 19.9974 10.5325C19.9465 10.617 19.9201 10.7141 19.9211 10.8128V13.0102C19.9211 13.2088 20.0227 13.3904 20.2094 13.4897L22.1604 14.5802C22.33 14.679 22.5507 14.679 22.7369 14.5802L24.0604 13.8363L24.9592 13.3242L26.2827 12.5808C26.4523 12.4815 26.6725 12.4815 26.8592 12.5808L27.894 13.1592C28.0641 13.258 28.1822 13.4396 28.1822 13.6382V14.8114C28.1822 15.0095 28.0811 15.1911 27.894 15.2904L26.8596 15.8853C26.6895 15.9846 26.4689 15.9846 26.2827 15.8853L25.2479 15.307C25.0778 15.2077 24.9592 15.0261 24.9592 14.8279V14.0676L24.0604 14.5802V15.3401C24.0604 15.5382 24.162 15.7203 24.3486 15.8191L26.2997 16.9095C26.4693 17.0088 26.6895 17.0088 26.8762 16.9095L28.8272 15.8191C28.9969 15.7203 29.1155 15.5387 29.1155 15.3401V13.1426C29.1165 13.0439 29.09 12.9469 29.0391 12.8623C28.9883 12.7777 28.9149 12.7089 28.8272 12.6636L26.8596 11.5561H26.8592Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1161_14646"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14.711,
    height: 14.711,
    fill: "white",
    transform: "translate(17.1628 5.72095)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsdtPolygon);
export default __webpack_public_path__ + "static/media/usdt_polygon.4f31f5b9eb91d2ba8124ee51f7b68117.svg";
export { ForwardRef as ReactComponent };